import { Injectable } from '@angular/core';
import { NgbDateParserFormatter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';
import { NgbDatepickerI18n } from '@ng-bootstrap/ng-bootstrap';
import { I18N_VALUES, ITALIA_INITIALS, KEY_LANGUAGE } from '../heplers/const-data';
import { isDefined } from '../heplers/helpers';
@Injectable({
  providedIn: 'root'
})
export class DatePickerDataFormatterService extends NgbDateParserFormatter {
  spliters = ['/', '-', '.', ' '];

  parse(value: string): NgbDateStruct {
    const spliter =  this.getDateSpliter(value);
    if (value && spliter) {
      const dateParts = value.split(spliter);
      const day = dateParts[0];
      const month = dateParts[1];
      const year = dateParts[2];
      if (dateParts.length === 1) {
        return { day: parseInt(day), month: null, year: null };
      } else if (dateParts.length === 2) {
        return { day: parseInt(day), month: parseInt(month), year: null };
      } else if (dateParts.length === 3) {
        return { day: parseInt(day), month: parseInt(month), year: parseInt(year) };
      }
    }
    return null;
  }

  formattTimePeriodToString(timePeriod) {
    return timePeriod.toString().length === 2? timePeriod.toString() : ("0" + timePeriod.toString());
  }

  format(date: NgbDateStruct): string {
    let day, month;
    if(date) {
      day = this.formattTimePeriodToString(date.day);
      month = this.formattTimePeriodToString(date.month);

      return `${date.day ? day : ''}-${date.month ? month : ''}-${date.year}`;
    }
    return '';
  }

  getDateSpliter(value: string) {
    for (const spliter of this.spliters) {
      if (value.includes(spliter)) {
        return spliter;
      }
    }
    return null;
  }
}

// Define custom service providing the months and weekdays translations
@Injectable()
export class CustomDatepickerI18n extends NgbDatepickerI18n {
  language = ITALIA_INITIALS;

  constructor() {
    super();
  }

  getWeekdayLabel(weekday: number): string {
    this.language = isDefined(localStorage.getItem(KEY_LANGUAGE)) ? localStorage.getItem(KEY_LANGUAGE) : ITALIA_INITIALS;
    return I18N_VALUES[this.language].weekdays[weekday];
  }

  getMonthShortName(month: number): string {
    this.language = isDefined(localStorage.getItem(KEY_LANGUAGE)) ? localStorage.getItem(KEY_LANGUAGE) : ITALIA_INITIALS;
    return I18N_VALUES[this.language].months[month - 1];
  }
  getMonthFullName(month: number): string {
    return this.getMonthShortName(month);
  }

  getDayAriaLabel(date: NgbDateStruct): string {
    return `${date.day}-${date.month}-${date.year}`;
  }
  getWeekdayShortName(weekday: number): string {
    const weekdays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
    return weekdays[weekday - 1]; // Adjust because weekdays are 1-based in ng-bootstrap
  }
}